import colors from "../../../utils/colors";
import Button from "../../../components/ui/button";
import { useNavigate } from "react-router-dom";
import { ILoginDetails } from "../../../types";
import { useRequestResetPassword } from "../../../apis/doctor";

const CheckYourEmail = ({ details }: { details: ILoginDetails }) => {
  const navigate = useNavigate();
  const { mutate, isPending } = useRequestResetPassword();

  return (
    <div className="w-full flex flex-col gap-5">
      <div
        className="font-lato text-[20px] font-[400] leading-normal"
        style={{ color: colors.dark }}
      >
        Didn't receive an email?
      </div>
      <Button
        theme="primary"
        text="Resend link"
        className="w-full rounded-md"
        onClick={() => mutate({ email: details?.email })}
        loading={isPending}
      />
      <Button
        theme="tertiary-primary"
        text="Back to Login"
        className="w-full rounded-md"
        onClick={() => navigate("/login")}
      />
    </div>
  );
};

export default CheckYourEmail;
